import Blue from "~/core";
import { Loader } from 'google-maps';

new Blue({
  name: "Map Marker",
  selector: ".map-marker",
  setup(mapMarker) {
    const mapDiv = mapMarker.querySelector(".map-marker__map");
    const approximateAddress = mapMarker.querySelector(".map-marker__address");
    const jurisdiction = mapMarker.querySelector(".map-marker__jurisdiction");
    const findOnMapButton = mapMarker.querySelector(".map-marker__find-on-map");

    const mapMarkerField = document.querySelector('[id$="MapMarker_MapData"]');
    const mapAddressField = document.querySelector('[id$="MapAddress_Value"]');
    const mapJurisdictionField = document.querySelector('[id$="MapJurisdiction_Value"]');
    const mapSourceField = document.querySelector('[id$="Source_Value"]');

    const loaderOptions = {
      version: "3.60",
      mapTypeId: "hybrid"
    };

    const loader = new Loader("AIzaSyAeOsOFUuNK4KkoFPjf-wu2zRBcf1HbTh4", loaderOptions);

    let map;
    let google;
    let geocoder;
    let marker;

    loader.load().then(function (g) {
      map = new g.maps.Map(mapDiv, {
        zoom: 15,
        center: { lat: 32.89686544, lng: -97.03982543 },
      });

      geocoder = new g.maps.Geocoder();
      google = g;
    }).then(() => {
      marker = new google.maps.Marker({
        map: map,
        position: new google.maps.LatLng(32.89686544, -97.03982543),
        draggable: true,
        title: 'Drag marker to the exact location.',
      });

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function (position) {
            var pos = new google.maps.LatLng(
              position.coords.latitude,
              position.coords.longitude
            );

            marker.setPosition(pos);
            map.setCenter(pos);

            google.maps.event.trigger(marker, 'dragend');
          },
          function () {
            handleNoGeolocation();
          }
        );
      } else {
        handleNoGeolocation();
      }

      google.maps.event.addListener(marker, 'dragend', function () {
        let mkrpos = marker.getPosition();
        approximateAddress.value = mkrpos;

        geocoder.geocode({ location: mkrpos }, function (results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            if (results[2]) {
              var latitude = results[2].geometry.location.lat();
              var longitude = results[2].geometry.location.lng();

              var latLngStrValue = "(" + latitude + ", " + longitude + ")";

              mapMarkerField.value = latLngStrValue;

              mapAddressField.value = results[0].formatted_address.slice(0, results[0].formatted_address.indexOf(', '));

              jurisdiction.value = results[2].formatted_address.slice(0, results[2].formatted_address.indexOf(', '));
              mapJurisdictionField.value = results[2].formatted_address.slice(0, results[2].formatted_address.indexOf(', '));
              approximateAddress.value = results[0].formatted_address;

              mapSourceField.value = "Web Form";
            } else {
              jurisdiction.value = "";
            }
          }
        });
      });

      var contentstring = 'Drag marker to refine its position on the map.';
      var infowindow = new google.maps.InfoWindow({ content: contentstring });

      infowindow.open(map, marker);
    });

    const handleNoGeolocation = () => {
      const pos = new google.maps.LatLng(32.89686544, -97.03982543);

      marker.setPosition(pos);
      map.setCenter(pos);
      map.setZoom(10);
    }

    const findMyLocation = () => {
      if (navigator.geolocation) {

        geocoder.geocode({ address: approximateAddress.value }, function (results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              var latitude = results[0].geometry.location.lat();
              var longitude = results[0].geometry.location.lng();

              var newpos = new google.maps.LatLng(latitude, longitude);

              marker.setPosition(newpos);
              map.setCenter(newpos);
              google.maps.event.trigger(marker, 'dragend');

            } else {
              jurisdiction.value = "";
            }
          }
        });

      } else {
        // Browser doesn't support Geolocation
        alert("Error: Your browser doesn't support geolocation.");
      }
    }

    this.$addEvents(findOnMapButton, "click", findMyLocation);
  }
});